const splitDateParts = (value) => {
        return value.split(/[ -.:;?!~,`"&|()<>{}\[\]\r\n/\\]+/);
    },
    transformDate = (dateParts) => {

        // default date
        let date = {
            year: 2017,
            month: 1,
            day: 1
        };

        date.year = Number(dateParts[2] || 2017);
        date.month = Number(dateParts[1]) - 1 || 0;
        date.day = Number(dateParts[0]);

        return date;
    };

export { splitDateParts };
export { transformDate };

export default {
    splitDateParts,
    transformDate
};
